import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

const COMPANY_CACHE_KEY = 'apms_company';

async function fetchCompanyPublic() {
  try {
    const r = await fetch('/api/public/company');
    if (r.ok) {
      const data = await r.json();
      localStorage.setItem(COMPANY_CACHE_KEY, JSON.stringify(data));
      return data;
    }
  } catch {}
  return null;
}

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [company, setCompany] = useState(() => {
    const cached = localStorage.getItem(COMPANY_CACHE_KEY);
    return cached ? JSON.parse(cached) : { name: '', website: '', email: '', city: '', state: '' };
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token    = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);

    // Always refresh company info on load
    fetchCompanyPublic().then(data => { if (data) setCompany(data); });
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    // Keep company cache on logout — login page needs it
    setUser(null);
  };

  const isAdmin = () => user?.role === 'ADMIN';

  return (
    <AuthContext.Provider value={{ user, company, login, logout, isAdmin, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
